import { render, staticRenderFns } from "./FailureLogs.vue?vue&type=template&id=33950f9e&"
import script from "./FailureLogs.vue?vue&type=script&lang=js&"
export * from "./FailureLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports